import React, { useState } from 'react';
import styled from 'styled-components';
import { SketchPicker } from 'react-color';
import { TextField, Button } from '@mui/material';
import LoadingOverlay from '../../mui/LoadingOverlay';
import { toast } from 'react-toastify';
import { AddNewgroups } from '../../redux/businessSlice';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useCreateGroupMutation } from '../../redux/organizationApi';
const CreateBusinessGroup = () => {
    const [businessNature, setBusinessNature] = useState('');
    const [businessColor, setBusinessColor] = useState('#fff');
    const [isColorPickerOpen, setIsColorPickerOpen] = useState(false);
    const [open,setOpen]=useState(false) ;
    const navigate=useNavigate();
 const dispatch=useDispatch();
 const [createGroup] = useCreateGroupMutation();
    const handleColorChange = (color) => {
        setBusinessColor(color.hex);
    };

    const handleColorBoxClick = () => {
        setIsColorPickerOpen(!isColorPickerOpen);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

            setOpen(true)
            try {
                const response= await createGroup({
                    businessNature,
                    businessColor,
                }).unwrap();
                if (response?.groups) {
                    dispatch(AddNewgroups(response.groups));
                }
                toast.success("Business Group create successfully")
                navigate('/admin/groupbusinesses')
            } catch (error) {
                toast.error(error?.data?.message || error?.error || "Failed to create business group")
            } finally {
                setOpen(false)
            }

    };

    return (
        <FormContainer className='mt-5'>
            <FormTitle>Create Business Group</FormTitle>
            <form onSubmit={handleSubmit}>
                <FormField>
                <TextField
  size="small"
  label="Business Group"
  variant="outlined"
  fullWidth
  value={businessNature}
  onChange={(e) => setBusinessNature(e.target.value)}
  inputProps={{
    style: { textTransform: 'capitalize' },
  }}
  required
/>

                </FormField>
                <FormField>
                    <Label>Business Color</Label>
                    <ColorPickerContainer className='d-flex justify-content-center'>
                        <ColorBox color={businessColor} onClick={handleColorBoxClick} />
                        {isColorPickerOpen && (
                            <SketchPicker
                                color={businessColor}
                                onChange={handleColorChange}
                            />
                        )}
                    </ColorPickerContainer>
                </FormField>
                <SubmitButton type="submit" variant="contained" color="primary">
                    Create Business Group
                </SubmitButton>
            </form>
           {open && <LoadingOverlay open={open} />}
        </FormContainer>
    );
};

export default CreateBusinessGroup;

const FormContainer = styled.div`
    max-width: 600px;
    margin: 20px auto;
    padding: 20px;
    background: #fdfdfd;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    @media (max-width: 600px) {
        padding: 15px;
        margin: 15px;
    }
`;

const FormTitle = styled.h3`
    text-align: center;
    margin-bottom: 20px;
    color: #333;
    font-family: 'Roboto', sans-serif;
`;

const FormField = styled.div`
    margin-bottom: 20px;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #333;
`;

const ColorPickerContainer = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;

const ColorBox = styled.div`
    width: 40px;
    height: 40px;
    background-color: ${(props) => props.color};
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 15px;
     display: flex;
    align-items: center;
`;

const SubmitButton = styled(Button)`
    width: 100%;
    padding: 10px;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
`;